
import { useState } from "react";
import { Shield } from "lucide-react";
import { Separator } from "@/components/ui/separator";

interface ContrastPoint {
  title: string;
  description: string;
}

interface HeroPathForwardProps {
  contrastPoints: ContrastPoint[];
}

export function HeroPathForward({ contrastPoints }: HeroPathForwardProps) {
  const [hoveredPoint, setHoveredPoint] = useState<number | null>(null);

  return (
    <>
      <div className="space-y-6 md:space-y-8 text-left max-w-lg mx-auto bg-cream/30 p-5 sm:p-6 md:p-8 rounded-sm shadow-sm mb-8 mx-3 sm:mx-auto">
        <div className="flex items-center">
          <Shield className="h-5 w-5 text-monasticSage mr-2" />
          <h2 className="text-xl sm:text-2xl mb-0 font-serif">The Path Forward</h2>
        </div>
        
        {contrastPoints.map((point, index) => (
          <div 
            key={index} 
            className="transition-all duration-300 transform hover:scale-102"
            onMouseEnter={() => setHoveredPoint(index)}
            onMouseLeave={() => setHoveredPoint(null)}
          >
            <div className="flex items-start">
              <div className="mr-5 pt-1">
                <div className={`w-[1px] h-6 bg-charcoal/50 transition-all duration-300 ${hoveredPoint === index ? 'h-8 bg-charcoal/70' : ''}`}></div>
              </div>
              <div className={`transition-all duration-300 ${hoveredPoint === index ? 'transform translate-x-[2px]' : ''}`}>
                <h3 className="text-lg sm:text-xl font-medium mb-2">{point.title}</h3>
                <p className="text-lg font-light text-charcoal leading-relaxed">{point.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="relative mb-4">
        <Separator className="my-6 md:my-8 bg-charcoal/10 h-[1px] w-24 mx-auto" />
      </div>
    </>
  );
}
